import { render, staticRenderFns } from "./DAGrayButton.vue?vue&type=template&id=a881ae8c"
import script from "./DAGrayButton.vue?vue&type=script&lang=js"
export * from "./DAGrayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports